import { render, staticRenderFns } from "./location-dialog.vue?vue&type=template&id=2f806b57"
import script from "./location-dialog.vue?vue&type=script&lang=js"
export * from "./location-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports